import { reviews } from "@/src/lib/data/reviews";

export function Review() {
  return (
    <div className="space-y-5 bg-white">
      <div className="mb-[15px] p-2.5">
        <h3 className="text-center font-['Montserrat'] text-[calc(17px+8*((100vw-320px)/960))] font-bold leading-none sm:text-[calc(18px+8*((100vw-320px)/960))] lg:text-[18px]">
          WHAT OUR CUSTOMERS ARE SAYING
        </h3>
      </div>

      <div>
        <img
          crossOrigin="anonymous"
          src="//img.funnelish.com/41178/302481/1711682357-ws35e4drxc.png"
          srcSet="//img.funnelish.com/41178/302481/1711682357-ws35e4drxc.png 1x"
          alt=""
          width="100%"
          height="auto"
          className="h-auto w-full"
        />
      </div>

      <div>
        <img
          crossOrigin="anonymous"
          src="//img.funnelish.com/41178/302481/1711682369-a3sw54edrxcytf.png"
          srcSet="//img.funnelish.com/41178/302481/1711682369-a3sw54edrxcytf.png 1x"
          alt=""
          width="100%"
          height="auto"
          className="h-auto w-full"
        />
      </div>

      <div>
        <img
          crossOrigin="anonymous"
          src="//img.funnelish.com/41178/302481/1711682379-w5szexrdcy.png"
          srcSet="//img.funnelish.com/41178/302481/1711682379-w5szexrdcy.png 1x"
          alt=""
          width="100%"
          height="auto"
          className="h-auto w-full"
        />
      </div>
    </div>
  );
}
